module.exports = __webpack_public_path__ + "static/img/6.9eb2fdd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jzsg/6.png
// module id = y1WL
// module chunks = 0